import { ProfilesStateProvider } from './ProfilesProvider';
import { SensorsStateProvider } from './SensorsProvider';

export type { Tenant, TenantPayload } from './useTenants';
export { useTenants, TENANTS_QUERY_KEY } from './useTenants';
export { useCreateTenant } from './useCreateTenant';
export { useUpdateTenant } from './useUpdateTenant';
export { useDeleteTenant } from './useDeleteTenant';
export { ProfilesState } from './ProfilesProvider';

// accessors
export { default as useSensorList } from './SensorsProvider/useSensorList';
export { default as useCheckSensorStatus } from './SensorsProvider/useCheckSensorStatus';
export { default as useGetSensorConfiguration } from './useGetSensorConfiguration';
export { default as useSensorPackages } from './useSensorPackages';
export { default as useTenantProfiles } from './useTenantProfiles';
export { default as useProfileSubmodules } from './useProfileSubmodules';
export { default as useCheckPcap } from './useCheckPcap';
export { usePcapProfiles } from './usePcapProfiles';

const SensorsProvider = ({ children }: { children: React.ReactNode }) => (
  <SensorsStateProvider>
    <ProfilesStateProvider>{children}</ProfilesStateProvider>
  </SensorsStateProvider>
);

export default SensorsProvider;
